import { render, staticRenderFns } from "./ModalInscripcionesProgramaUniversidad.vue?vue&type=template&id=fa5e8c22"
import script from "./ModalInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalInscripcionesProgramaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports